// extracted by mini-css-extract-plugin
export default {"Rcard":"ReferralCard_Rcard__8vsYZ","ReferralTxt":"ReferralCard_ReferralTxt__xN-7x"};